import { render } from "./CreditLimitInfo.vue?vue&type=template&id=612ab7c8&scoped=true"
import script from "./CreditLimitInfo.vue?vue&type=script&lang=js"
export * from "./CreditLimitInfo.vue?vue&type=script&lang=js"

import "./CreditLimitInfo.vue?vue&type=style&index=0&id=612ab7c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612ab7c8"]])

export default __exports__